export enum ApprovalMode {
  NONE = 1,
  REQUIRED = 2
}
